// hooks/usePageTracking.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getStoredUtmData } from './useUtmTracking';

export function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        // Get stored UTM data to include in GA events
        const utmData = getStoredUtmData();
        
        // Build event parameters
        const eventParams: Record<string, any> = {
            page_path: location.pathname + location.search,
            page_title: document.title,
        };
        
        // Include UTM parameters if available
        if (utmData) {
            if (utmData.utm_source) eventParams.utm_source = utmData.utm_source;
            if (utmData.utm_medium) eventParams.utm_medium = utmData.utm_medium;
            if (utmData.utm_campaign) eventParams.utm_campaign = utmData.utm_campaign;
            if (utmData.utm_term) eventParams.utm_term = utmData.utm_term;
            if (utmData.utm_content) eventParams.utm_content = utmData.utm_content;
        }
        
        window.gtag?.('event', 'page_view', eventParams);
    }, [location]);
}